import { boolFromUnknown, intFromUnknown, strFromUnknown } from '@/lib/primitive-utils';
import { LabeledCheckboxRow, LabeledNumberRow, LabeledTextRow } from './shared/field-primitives';
import type { BuilderPropertyRecord, ShortAnswerToolSettingsProps } from './tool-defaults';

export function selectStringMatchToolProps(p: BuilderPropertyRecord) {
    return {
        lines: intFromUnknown(p.lines, 1),
        columns: intFromUnknown(p.columns, 20),
        obeyspace: boolFromUnknown(p.obeyspace),
        obeycase: boolFromUnknown(p.obeycase),
        obeyquote: p.obeyquote !== undefined ? boolFromUnknown(p.obeyquote) : true,
        obeylinear: boolFromUnknown(p.obeylinear),
        preferred: boolFromUnknown(p.preferred),
        ignoreend: strFromUnknown(p.ignoreend, ''),
    };
}

function StringMatchToolSettingsInner({
    lines,
    columns,
    obeyspace,
    obeycase,
    obeyquote,
    obeylinear,
    preferred,
    ignoreend,
    onPatch,
}: ReturnType<typeof selectStringMatchToolProps> & {
    onPatch: (patch: BuilderPropertyRecord) => void;
}) {
    return (
        <div className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
                <LabeledNumberRow
                    label="Lines"
                    placeholder="Ex: 1"
                    value={lines}
                    onIntChange={n => onPatch({ lines: n })}
                />
                <LabeledNumberRow
                    label="Columns"
                    placeholder="Ex: 10"
                    value={columns}
                    onIntChange={n => onPatch({ columns: n })}
                />
            </div>
            <LabeledTextRow
                label="Optional: Ignore at end"
                value={ignoreend}
                rows={1}
                onValueChange={v => onPatch({ ignoreend: v })}
            />
            <div className="grid grid-cols-3 gap-3">
                <LabeledCheckboxRow
                    label="Obey space"
                    checked={obeyspace}
                    onCheckedChange={v => onPatch({ obeyspace: v })}
                />
                <LabeledCheckboxRow
                    label="Obey case"
                    checked={obeycase}
                    onCheckedChange={v => onPatch({ obeycase: v })}
                />
                <LabeledCheckboxRow
                    label="Quote sensitive"
                    checked={obeyquote}
                    onCheckedChange={v => onPatch({ obeyquote: v })}
                />
                <LabeledCheckboxRow
                    label="Obey linear"
                    checked={obeylinear}
                    onCheckedChange={v => onPatch({ obeylinear: v })}
                />
                <LabeledCheckboxRow
                    label="Explanation shows only first answer"
                    checked={preferred}
                    onCheckedChange={v => onPatch({ preferred: v })}
                />
            </div>
        </div>
    );
}

export function StringMatchToolSettings({ builderProps, onPatch }: ShortAnswerToolSettingsProps) {
    return (
        <StringMatchToolSettingsInner
            {...selectStringMatchToolProps(builderProps)}
            onPatch={onPatch}
        />
    );
}
